import { z } from "zod";

// Series wizard autosaves a partial draft every 30s. Stored as opaque JSON
// keyed by adminUserId — the wizard knows how to deserialize back into its
// own form state. Schema kept loose on purpose; the wizard owns validation.
export const seriesDraftSchema = z.object({
  _id: z.string(),
  adminUserId: z.string(),
  slug: z.string().optional(),
  // Versioned JSON blob — wizard step shape may evolve.
  payload: z.record(z.unknown()),
  // Set once the admin clicks "Publish" / "Save draft" successfully.
  finalized: z.boolean().default(false),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type SeriesDraft = z.infer<typeof seriesDraftSchema>;
